import React from 'react';
export default (function (props) {
  var color = props.color,
      size = props.size,
      className = props.className,
      style = props.style;
  color = color ? color : 'currentColor';
  size = size ? size : '100%';
  return /*#__PURE__*/React.createElement("svg", {
    style: style,
    className: className,
    width: size,
    height: size,
    fill: color,
    viewBox: "0 0 24 24",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    id: "info",
    stroke: "none",
    strokeWidth: "1",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13,13 L11,13 L11,7.00000002 L13,7.00000002 L13,13 Z M13,17.0000001 L11,17.0000001 L11,15.0000001 L13,15.0000001 L13,17.0000001 Z M12,2 C6.48000002,2 2,6.48000002 2,12 C2,17.5200001 6.48000002,22 12,22 C17.5200001,22 22,17.5200001 22,12 C22,6.48000002 17.5200001,2 12,2 Z",
    id: "\uD83C\uDFA8-Icon-Color",
    transform: "translate(12.000000, 12.000000) scale(1, -1) translate(-12.000000, -12.000000) "
  })));
});